export default {
  guides: {
    sectionTitle: "Szczegółowe przewodniki USFans",
    sectionSubtitle: "Dziesięć praktycznych przewodników obejmujących wszystko, od bezpiecznych zakupów po wysyłkę, kupony, legalność i prywatność.",
    readMore: "Przeczytaj przewodnik",
    items: [
      {
        title: "Przewodnik zakupowy USFans: jak kupować pewnie",
        desc: "Instrukcja krok po kroku, jak przeglądać USFans, wybierać odpowiedni produkt i bezpiecznie dokończyć zakup.",
      },
      {
        title: "Arkusz USFans: kompletny przewodnik",
        desc: "Dowiedz się, czym jest arkusz USFans, jak działają jego kategorie i jak szybko się po nim poruszać.",
      },
      {
        title: "Recenzja USFans: funkcje, zalety i wady",
        desc: "Szczere spojrzenie na funkcje platformy, jej zalety, ograniczenia i rzeczy, na które warto uważać.",
      },
      {
        title: "Koszt wysyłki USFans: kompletny przewodnik",
        desc: "Poznaj czynniki wpływające na ceny wysyłki i dowiedz się, jak oszacować koszty dostawy w swoim regionie.",
      },
      {
        title: "Kupon USFans: jak znaleźć prawdziwe oferty",
        desc: "Praktyczny przewodnik po znajdowaniu autentycznych promocji i zrozumieniu, jak działają kupony USFans.",
      },
      {
        title: "Kod rabatowy USFans: jak zweryfikować oferty",
        desc: "Jak sprawdzić, czy kod rabatowy jest ważny przed finalizacją zamówienia i unikać wygasłych lub fałszywych ofert.",
      },
      {
        title: "Magazyn USFans: przewodnik po przechowywaniu",
        desc: "Wszystko, co musisz wiedzieć o przechowywaniu, przetwarzaniu zamówień i czasie realizacji.",
      },
      {
        title: "Czy USFans jest legalny? Co wiedzieć przed zakupem",
        desc: "Jak ocenić wiarygodność, zaufanie i sygnały bezpieczeństwa przed złożeniem zamówienia.",
      },
      {
        title: "Bezpieczeństwo USFans: chroń konto i prywatność",
        desc: "Praktyczne zalecenia dotyczące bezpieczeństwa konta, płatności i danych osobowych.",
      },
      {
        title: "Prywatność USFans: jak przetwarzane są dane",
        desc: "Przejrzysty przegląd kwestii prywatności i tego, jak chronić dane osobowe podczas zakupów.",
      },
    ],
    detail: {
      pointsTitle: "O czym pamiętać",
      points: [
        "Zawsze weryfikuj aktualne ceny, rozmiary i dostępność w głównym sklepie przed zakupem.",
        "Sprawdź koszt wysyłki i szacowany czas dostawy dla swojego regionu.",
        "Potwierdź kupon lub kod rabatowy bezpośrednio przy kasie, zanim na nim polegniesz.",
        "Korzystaj z oficjalnych lub zaufanych źródeł i chroń dane osobowe oraz płatnicze.",
      ],
      relatedTitle: "Więcej przewodników USFans",
      visitMain: "Odwiedź główną stronę",
      backHome: "Wróć na stronę główną",
    },
  },
};